import { React, PropTypes } from 'imports';
import Popup, { CloseMode } from '../Popup/Popup';
import { FormattedResource } from '..';
import './ConfirmationDialog.less';

export default class ConfirmationDialog extends React.Component {
    static get propTypes() {
        return {
            title: FormattedResource.resourcePropType.isRequired,
            description: FormattedResource.resourcePropType.isRequired,
            warning: FormattedResource.resourcePropType,
            confirm: FormattedResource.resourcePropType.isRequired,
            cancel: FormattedResource.resourcePropType,
            onConfirm: PropTypes.func.isRequired,
            onCancel: PropTypes.func,
            className: PropTypes.string
        };
    }

    static get defaultProps() {
        return {
            title: { id: 'common.delete_item' },
            description: { id: 'common.delete_item_description' },
            warning: { id: 'common.delete_item_warning' },
            confirm: { id: 'common.delete' },
            cancel: { id: 'common.cancel' },
            className: ''
        }
    }

    _onConfirmClick = () => {
        this.props.onConfirm(this);
    }

    _onCancelClick = () => {
        this.props.onCancel(this);
    }

    render() {
        return (
            <Popup dimmed closeMode={null} className={'confirmation-dialog ' + this.props.className}>
                {
                    this.props.title ?
                        <div className="title">
                            <FormattedResource resource={this.props.title} />
                        </div> :
                        null
                }
                {
                    this.props.description ?
                        <div className="description">
                            <FormattedResource resource={this.props.description} />
                        </div> :
                        null
                }
                {
                    this.props.warning ?
                        <div className="warning">
                            <span className="fa  fa-exclamation-circle" />
                            <FormattedResource resource={this.props.warning} />
                        </div> :
                        null
                }
                <div className="buttons">
                    <button className="primary" onClick={this._onConfirmClick}>
                        <FormattedResource resource={this.props.confirm} />
                    </button>
                    {
                        this.props.cancel ?
                            <button onClick={this._onCancelClick}>
                                <FormattedResource resource={this.props.cancel} />
                            </button> :
                            null
                    }
                </div>
            </Popup>
        );
    }
}